import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.travelQuestions.replace(appPath.travel, ''),
	components: () => [import(/* webpackChunkName: 'travelQuestions' */ './component')],
	render: ([TravelQuestions]) => <TravelQuestions />,
};

export default routes;
